import { WHATSAPP_TEMPLATE_STATUS as S, statusLabel } from '../../utils/whatsapp';

const STATUS_STYLES = {
  [S.APPROVED]:
    'bg-green-50 dark:bg-green-950/50 text-green-800 dark:text-green-300 border-green-200 dark:border-green-900',
  [S.PENDING]:
    'bg-amber-50 dark:bg-amber-950/50 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-900',
  [S.REJECTED]: 'bg-red-50 dark:bg-red-950/50 text-red-800 dark:text-red-300 border-red-200 dark:border-red-900',
};

const PILL = 'inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full whitespace-nowrap';

const DYNAMIC_PLACEHOLDER = /\{\{\s*\d+\s*\}\}/;

/**
 * A button link containing {{n}} is filled per recipient. The campaign wizard can do this (mapped
 * to product_slug), but the single-contact TemplateSendPanel has no per-recipient context to fill it.
 */
export const hasDynamicLink = (template) =>
  (template.buttons || []).some((button) => DYNAMIC_PLACEHOLDER.test(button?.url ?? ''));

/**
 * The templates as selectable rows. Labels are real text (never colour alone); statusLabel also
 * capitalises the category ("marketing" -> "Marketing").
 * @param {{templates: any[], selectedId: string | null, onSelect: (id: string) => void}} props
 */
const TemplateList = ({ templates, selectedId, onSelect }) => (
  <section aria-label="Templates">
    <ul className="space-y-2">
      {templates.map((template) => {
        const selected = template.id === selectedId;
        const count = template.variable_count || 0;
        return (
          <li key={template.id}>
            <button
              type="button"
              data-testid={`template-${template.name}`}
              aria-pressed={selected}
              aria-current={selected ? 'true' : undefined}
              onClick={() => onSelect(template.id)}
              className={`w-full text-left p-3 bg-card border rounded-lg transition-colors ${
                selected ? 'border-foreground ring-1 ring-foreground' : 'border-border hover:border-muted-foreground'
              }`}
            >
              <span className="flex flex-wrap items-start justify-between gap-2">
                <span className="min-w-0">
                  <span className="block font-medium text-foreground break-all">{template.name}</span>
                  <span className="block text-sm text-muted-foreground">
                    {template.language} - {count} {count === 1 ? 'variable' : 'variables'}
                  </span>
                </span>
                <span className="flex flex-wrap gap-1">
                  <span className={`${PILL} bg-muted/50 text-foreground/80 border-border`}>
                    {statusLabel(template.category)}
                  </span>
                  <span className={`${PILL} ${STATUS_STYLES[template.status] ?? STATUS_STYLES[S.PENDING]}`}>
                    {statusLabel(template.status)}
                  </span>
                </span>
              </span>
              {hasDynamicLink(template) && (
                <span className="block mt-2 text-xs text-amber-800 dark:text-amber-300">
                  Needs a product link mapped per recipient in the campaign wizard
                </span>
              )}
            </button>
          </li>
        );
      })}
    </ul>
  </section>
);

export default TemplateList;
